import { useParams } from 'react-router-dom';

const useSessionIdFromParams = () => {
  const { sessionId } = useParams<{ sessionId: string }>();

  return sessionId ?? null;
};

export { useSessionIdFromParams };
